import { Flex } from "@chakra-ui/react";
import { useOverlay } from "@toss/use-overlay";
import {
  Button,
  call,
  ColorIcon,
  colors,
  customEvent,
  FUNERAL_SIGUNGU,
  HackleEventName,
  HStack,
  useResponsive,
  VStack,
} from "goi_common";
import { ParlorDetailProps } from "@/types/parlor";
import { useState } from "react";
import FileRequestModal from "./Modal/FileRequestModal";
import ParlorCompareModal from "./ParlorCompareModal";

const ParlorFixedButtons = ({
  parlor,
  selectedSangjo,
  closestParlors,
}: {
  parlor: ParlorDetailProps;
  selectedSangjo: string;
  closestParlors: any;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isBiggerThanMd } = useResponsive();
  const overlay = useOverlay();

  return (
    <VStack
      alignItems="center"
      width="100%"
      position="fixed"
      style={{
        bottom: 0,
      }}
    >
      <VStack width="100%" alignItems="center">
        <VStack width="100%" maxWidth="480px">
          <Flex width="100%" alignItems="flex-end" justifyContent="end" pb="12px" pr="20px">
            <HStack
              width="300px"
              borderRadius="6px"
              boxShadow="0px 4px 12px rgba(0, 0, 0, 0.5)"
              height="40px"
              className="caption_12_b gray800"
              background="white"
              alignItems="center"
              padding="12px"
              gap={6}
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "parlor_detail",
                    trigger_and_target: "footer_floating-checklist",
                  },
                });
                overlay.open(({ isOpen, close: onClose }) => {
                  return <FileRequestModal isOpen={isOpen} onClose={onClose} />;
                });
              }}
            >
              <div>장례 비용 예상 견적표, 임종 준비 체크리스트 받아보기</div>
              <ColorIcon name="icon-arrow-right-circle-mono" size={14} color={colors.gray700} />
            </HStack>
          </Flex>
        </VStack>

        <VStack width="100%" background={colors.gray50} alignItems="center">
          <HStack
            width="100%"
            maxWidth="480px"
            height={"64px"}
            css={{
              margin: 0,
              height: 48,
              bottom: isBiggerThanMd ? 0 : 0,
              zIndex: 5,
            }}
          >
            <HStack width="100%" height="100%" padding={"4px 20px 12px"} gap={8}>
              <Button
                style={{
                  color: "white",
                  width: "50%",
                  height: "100%",
                  backgroundColor: colors.black,
                  borderRadius: "5px",
                }}
                className="button"
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: "parlor_detail",
                      trigger_and_target: "footer_compare-open_compare_modal",
                    },
                    hackle: { key: HackleEventName["장례식장 상세 푸터 - 비교하기"] },
                  });
                  setIsOpen(true);
                }}
              >
                <div className="caption1">
                  {FUNERAL_SIGUNGU.get(Number(parlor.sido))?.get(Number(parlor.sigungu))} 장례식장
                  비용
                </div>
                <HStack className="button_14_sb" alignItems="center" justifyContent="center">
                  <div>전체 비교하기</div>
                  <ColorIcon name="icon-arrow-right-small-mono" size={16} color="white" />
                </HStack>
              </Button>
              <Button
                style={{
                  color: "white",
                  width: "50%",
                  height: "100%",
                  backgroundColor: colors.black,
                  borderRadius: "5px",
                }}
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: "parlor_detail",
                      trigger_and_target: "footer_lft-quickcall_modal",
                    },
                  });
                  call("1666-9784");
                  // onQuickCallModal();
                }}
                className="button"
              >
                <VStack alignItems="center" gap={0} justifyContent="center">
                  <div className="caption1">24시간 전화상담</div>
                  <HStack
                    className="button_14_sb"
                    alignItems="center"
                    justifyContent="center"
                    gap={6}
                  >
                    <div>임종접수/빈소문의</div>
                    <ColorIcon name="icon-call-mono" size={16} color="white" />
                  </HStack>
                </VStack>
              </Button>
            </HStack>
          </HStack>
        </VStack>
      </VStack>
      <ParlorCompareModal
        closestParlors={closestParlors}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        parlor={parlor}
        selectedSangjo={selectedSangjo}
      />
    </VStack>
  );
};

export default ParlorFixedButtons;
